import { FinishingContainer } from '../../containers/advancedFilters/FinishingContainer';
import { IFilter } from '../../types/advancedFilters';

export const finishing: IFilter = {
  component: FinishingContainer,
};
